module.exports = __webpack_public_path__ + "img/cartagena.763a7e6c.jpg";